// @flow

import * as React from 'react';

import { useParams } from 'react-router-dom';

import {
  selectCartIsResuming,
  selectCountItems,
  selectCartIsDeleted,
  selectCartIsNotCreated,
} from '@gandi/cart';
import { Spinner } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectIsAppWorking } from '../../modules/app';
import type { PreFetchArgs, PreFetchReturn } from '../../types';

import { ContactWizardAlert } from './ContactWizardAlert';
import { CorporateAlert } from './CorporateAlert';
import { EmptyCart } from './EmptyCart';
import InvoiceTo from './InvoiceTo';
import { Products } from './Products';
import { Suggestions } from './Suggestions';

import styles from './Overview.scss';

type Params = {
  cartId: string,
  orderId?: string,
};

export default function Overview(): React.MixedElement {
  const { orderId } = useParams<Params>();
  const countItems = useAppSelector(selectCountItems);
  const isCartResuming = useAppSelector(selectCartIsResuming);
  const isAppLoading = useAppSelector(selectIsAppWorking);
  const isCartDeleted = useAppSelector(selectCartIsDeleted);
  const isCartNotCreated = useAppSelector(selectCartIsNotCreated);

  if (isCartResuming || isAppLoading) {
    return <Spinner centered />;
  }

  if (countItems === 0 || isCartDeleted || isCartNotCreated) {
    return <EmptyCart />;
  }

  return (
    <div className={styles.root}>
      <ContactWizardAlert />
      <Products />
      <CorporateAlert />
      {!orderId && <Suggestions />}
      <InvoiceTo />
    </div>
  );
}

Overview.preFetch = (args: PreFetchArgs<{}>): PreFetchReturn<> =>
  InvoiceTo.preFetch(args);
